// Adds desktop drag-to-scroll to Dawn slider components.
(function () {
  function initDragScroll(slider) {
    if (slider.dataset.dragScrollInitialized === 'true') return;
    slider.dataset.dragScrollInitialized = 'true';

    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.style.cursor = 'grabbing';
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.style.cursor = 'grab';
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.style.cursor = 'grab';
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5;
      slider.scrollLeft = scrollLeft - walk;
    });

    slider.style.cursor = 'grab';
    slider.style.scrollSnapType = 'x mandatory';
    slider.style.overflowX = 'auto';
    slider.style.scrollBehavior = 'smooth';
    slider.style.webkitOverflowScrolling = 'touch';
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('slider-component').forEach((section) => {
      const slider = section.querySelector('ul.slider--desktop, ul.slider');
      if (!slider) return;
      initDragScroll(slider);
    });
  });
})();
